import { type AdvertiserTypeEnum } from '@/lib/types/advertiser.types'

export const mapAdvertiserTypeName = (type: AdvertiserTypeEnum): string => {
  return {
    MANAGED: 'Managed',
    SELF_SERVICE: 'Self-service',
  }[type]
}
